import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ISettingsRegistrationFieldsResponse } from '../types';
import {
  ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_PERMISSIONS,
  SETTINGS_REGISTRATION_FIELDS_LIST_QUERY_KEY,
  SETTINGS_REGISTRATION_FIELDS_LIST_URL,
} from '../constants';

export default function useSettingsRegistrationFieldsListQuery(): IContextQueryResult<ISettingsRegistrationFieldsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsRegistrationFieldsResponse, Error>({
    queryKey: [SETTINGS_REGISTRATION_FIELDS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_REGISTRATION_FIELDS_LIST_URL, {
      signal,
      permission: ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_PERMISSIONS.PROJECTSETTINGS_REQUIRED_FIELDS_IN_PROFILE_UPDATE,
    }),
  });
}
